import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountUpdate } from '../../../../core/model/account-update.model';
import { SellerAccountView } from '../../../../core/model/seller-account-view.model';
import { MainService } from '../../main.service';
import { MatDialog } from '@angular/material/dialog';
import { OnboardingAlertDialogComponent } from '../../../../component/onboarding-alert-dialog/onboarding-alert-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class SellerService {

  constructor(
    private _mainService: MainService,
    private _dialog: MatDialog
  ) {
  }

  get user(): SellerAccountView {
    return this._mainService.user as SellerAccountView;
  }

  set user(value: SellerAccountView) {
    this._mainService.user = value;
  }

  public getAccount(): Observable<SellerAccountView> {
    return this._mainService.getAccount() as Observable<SellerAccountView>;
  }

  public updateAccount(account: AccountUpdate): Observable<SellerAccountView> {
    return this._mainService.updateAccount(account) as Observable<SellerAccountView>;
  }

  checkAndShowOnboardingAlert(): void {
    const user = this.user;

    console.log('Checking onboarding alert for user:', user);

    if (!user) {
      console.log('No user data available');
      return;
    }

    // Controlla se l'onboarding non è completato
    const onboardingStatus = (user as any).onboardingStatus;

    console.log('Onboarding status:', onboardingStatus);

    if (!onboardingStatus || onboardingStatus === 'CREATED') {
      console.log('Showing onboarding alert dialog');
      // Mostra la dialog di alert
      this._dialog.open(OnboardingAlertDialogComponent, {
        width: '400px',
        disableClose: false,
        data: { user: user }
      });
    } else {
      console.log('Onboarding is completed, not showing dialog');
    }
  }
}
